import React, { useState, useEffect } from "react";
import { getAllCategories } from "../../services/photoCategoryService";
import { uploadPhotos } from "../../services/photoService";

export default function AdminPhotoUpload() {
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    categoryId: "",
    title: "Default Photo Title",
    discription: "Default photo description",
    uploadedBy: "Admin",
    photos: [],
  });

  useEffect(() => {
    getAllCategories().then(setCategories);
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("categoryId", formData.categoryId);
    fd.append("title", formData.title);
    fd.append("discription", formData.discription);
    fd.append("uploadedBy", formData.uploadedBy);

    for (let i = 0; i < formData.photos.length; i++) {
      fd.append("photos", formData.photos[i]);
    }

    await uploadPhotos(fd);
    alert("Photos uploaded successfully!");
    setFormData({
      categoryId: "",
      title: "",
      discription: "",
      uploadedBy: "Admin",
      photos: [],
    });
  };

  return (
    <form onSubmit={handleSubmit} className="p-3 border rounded shadow-sm mt-3">
      <h5>Upload Photos</h5>
      <div className="mb-3">
        <label className="form-label">Select Category</label>
        <select
          className="form-select"
          name="categoryId"
          value={formData.categoryId}
          onChange={handleChange}
          required
        >
          <option value="">-- Select --</option>
          {categories.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
      </div>

      <input
        type="text"
        name="title"
        className="form-control mb-2 d-none"
        placeholder="Photo Title"
        value={formData.title || "Default Photo Title"}
        onChange={handleChange}
        
      />

      <textarea
        name="discription"
        className="form-control mb-2 d-none"
        placeholder="Description"
        value={formData.discription || "Default photo description"}
        onChange={handleChange}
      ></textarea>

      <input
        type="file"
        multiple
        name="photos"
        accept="image/*"
        className="form-control mb-3"
        onChange={handleChange}
      />

      <button type="submit" className="btn btn-success w-100">
        Upload Photos
      </button>
    </form>
  );
}
